import * as t from "io-ts";

export const TradeType = t.union([
  t.literal("air_conditioning"),
  t.literal("artificial_grass_specialists"),
  t.literal("bathrooms"),
  t.literal("battery_storage"),
  t.literal("blinds_and_shutters"),
  t.literal("carpentry"),
  t.literal("cctv_and_security_installations"),
  t.literal("cladding_sofits_and_guttering"),
  t.literal("conservatories"),
  t.literal("curtains"),
  t.literal("decking"),
  t.literal("driveways_and_patios"),
  t.literal("electrician"),
  t.literal("ev_charger_installer"),
  t.literal("fencing"),
  t.literal("fireplaces"),
  t.literal("fitted_bedroom_furniture"),
  t.literal("floor_layer"),
  t.literal("garage_doors"),
  t.literal("garden_rooms"),
  t.literal("gas_engineer"),
  t.literal("gates"),
  t.literal("heat_pumps"),
  t.literal("heating_systems"),
  t.literal("home_insulation_excl_spray_foam"),
  t.literal("hot_tub_specialist"),
  t.literal("kitchen_fitter"),
  t.literal("kitchen_supplier"),
  t.literal("landscaping"),
  t.literal("loft_boarding"),
  t.literal("painting_and_decorating"),
  t.literal("plasterer"),
  t.literal("plumbing"),
  t.literal("rendering"),
  t.literal("resin_drive_specialist"),
  t.literal("resin_driveways"),
  t.literal("roofing__excluding_flat_roofs"),
  t.literal("security_systems"),
  t.literal("stair_case_specialist"),
  t.literal("tiler"),
  t.literal("verandas"),
  t.literal("windows_and_doors"),
  t.literal("multi_trade"),
  t.literal("other_trade"),
]);

export type TradeType =
  | "air_conditioning"
  | "artificial_grass_specialists"
  | "bathrooms"
  | "battery_storage"
  | "blinds_and_shutters"
  | "carpentry"
  | "cctv_and_security_installations"
  | "cladding_sofits_and_guttering"
  | "conservatories"
  | "curtains"
  | "decking"
  | "driveways_and_patios"
  | "electrician"
  | "ev_charger_installer"
  | "fencing"
  | "fireplaces"
  | "fitted_bedroom_furniture"
  | "floor_layer"
  | "garage_doors"
  | "garden_rooms"
  | "gas_engineer"
  | "gates"
  | "heat_pumps"
  | "heating_systems"
  | "home_insulation_excl_spray_foam"
  | "hot_tub_specialist"
  | "kitchen_fitter"
  | "kitchen_supplier"
  | "landscaping"
  | "loft_boarding"
  | "painting_and_decorating"
  | "plasterer"
  | "plumbing"
  | "rendering"
  | "resin_drive_specialist"
  | "resin_driveways"
  | "roofing__excluding_flat_roofs"
  | "security_systems"
  | "stair_case_specialist"
  | "tiler"
  | "verandas"
  | "windows_and_doors"
  | "multi_trade"
  | "other_trade";
